// Facade del bloque backoffice de `retail-org-business` (KPIs de tiendas y vendedores, metas).
//
// 🔴 **NO HAY ADAPTER MOCK, y no se vuelve a agregar.** Ver el porqué en el facade del wizard.
import {
    goalsClient,
    sellerKpisClient,
    storeActivityClient,
    storeKpisClient,
} from './backoffice.client';

export const storeKpisApi = storeKpisClient;
export const sellerKpisApi = sellerKpisClient;
export const goalsApi = goalsClient;
export const storeActivityApi = storeActivityClient;

export type {
    Financier,
    Goal,
    GoalListResponse,
    GoalsApi,
    GoalTargetType,
    KpiWindow,
    SellerKpiDetail,
    SellerKpiRow,
    SellerKpisApi,
    SellerKpisResponse,
    SellerSaleRow,
    FinancierMixSlice,
    StoreActivityApi,
    StoreActivityResponse,
    StoreActivityRow,
    StoreKind,
    StoreKpiDetail,
    StoreKpiRow,
    StoreKpisApi,
    StoreKpisResponse,
    StoreSellerRow,
} from './contract';
